import { t } from 'i18next';
import { getStaticAssetUrl } from 'utils/url';

export const ecosystemData = {
  [t('ecosystem:PARTNERS')]: [
    {
      title: 'Outlier Ventures',
      description:
        "Founded in 2014,Outlier Ventures is the world's leading global Web3 accelerator.",
      Link: 'https://outlierventures.io/',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/Sfi_Cluster_Protocol.svg'),
      category: 'Accelerator',
      backDetails:
        "Founded in 2014, Outlier Ventures is the world's leading global Web3 accelerator with an investment portfolio of over 350 portfolio projects with a combined valuation approaching USD 11 billion.",
    },
    {
      title: 'Gelato',
      description: 'The all-in-one Ethereum Rollup as a Service Platform',
      Link: '#',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/Sfi_Gelato.svg'),
      backDetails:
        'Gelato provides limitless, secure, and scalable Ethereum Rollup-as-a-Service, enabling fast Layer 2 chain deployment integrated with top Web3 tools like Etherscan and The Graph.',
      category: 'RAAS Services',
    },
    {
      title: 'Zoth',
      description:
        'Zoth is a retail-focused RWA ecosystem that is bringing fixed-yield generating, institutional grade, high-quality RWAs on-chain.',
      Link: 'https://zoth.io/',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/Sfi_Zoth.svg'),
      category: 'RWA',
      backDetails:
        'Zoth allows users to collateralize their off-chain or on-chain tokenized assets (TBILLs, ETFs, MMFs etc.) to issue ZeUSD, a yield bearing stable token, which can unlock DeFi access on top of existing RWAs.',
    },
    {
      title: 'Particula',
      description:
        'Real-time risk assessment and monitoring for tokenized assets',
      Link: 'https://particula.io/',
      category: 'RWA Analytics',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/Sfi_Particula.svg'),
      backDetails:
        'Particula provides next-generation risk assessments and monitoring for tokenized assets, reducing due diligence times while enhancing security, market access, and insights for financial leaders worldwide',
    },
    {
      title: 'Rebalance Finance',
      description:
        'AI-powered protocol for higher yields across the DeFi and RWA market',
      Link: 'https://www.rebalance.finance/',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/Sfi_Rebalance.svg'),
      category: 'DeFi',
      backDetails:
        'AI-powered protocol for higher yields across the DeFi and RWA $10T market. Get maximum returns with minimal risks through automated fund distribution among verified providers.',
    },
    {
      title: 'Cluster Protocol',
      description:
        'Elevate your portfolio with advanced AI driven DeFi products',
      Link: 'https://www.clusterprotocol.ai/',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/Sfi_Cluster_Protocol.svg'),
      category: 'AI Co-ordination Layer',
      backDetails:
        'Cluster Protocol is the co-ordination layer for AI agents, a carnot engine fueling the AI economy making sure the AI developers are monetized for their AI models and users get an unified seamless experience to build that next AI app/ agent within a virtual disposable environment facilitating the creation of modular, self-evolving AI agents.',
    },
    {
      title: 'Kommunitas',
      description:
        'Decentralized Crowdfunding Platform for web3.0 projects with Revenue-Sharing Mechanism',
      Link: 'https://kommunitas.net/',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/KOM.svg'),
      category: 'Launchpad',
      backDetails:
        'Kommunitas is a decentralized crowdfunding ecosystem powered by KOM tokens, offering tier-less participation, revenue sharing, and fair opportunities for all crypto users.',
    },
    {
      title: 'Allnodes',
      description:
        'Allnodes is a non-custodial platform for staking and node hosting.',
      Link: 'https://www.allnodes.com/',
      category: 'Node Infrastructure',
      logo: getStaticAssetUrl('/sfi/static/ecosystem/allnodes.svg'),
      backDetails:
        'Allnodes is a non-custodial staking platform hosting over 38,000 nodes worth $5.8 billion across 80 blockchain networks for validators and investors.',
    },
  ],
};
